import React from "react";
 import { Navigate } from "react-router";

const PrivateRoute = ({children}) =>{
 const userLogn = JSON.parse(sessionStorage.getItem("user"));   
 
return userLogn && userLogn.data.access_token ? children : <Navigate to={"/Login"} />
}
export default PrivateRoute